import { getString } from 'firebase/remote-config';
import { create } from 'zustand';
import { mainRemoteConfig } from 'config/firebase';
import { CUSTOM_MESSAGE_POPUP } from '@globalConstants';

interface CustomMessagePopupConfig {
  enabled: boolean;
  title: string;
  message: string;
  showCloseButton: boolean;
  showConfirmButton: boolean;
  confirmButtonText: string;
}

interface CustomMessagePopupState {
  config: CustomMessagePopupConfig | null;
  isLoaded: boolean;
  loadConfig: () => Promise<void>;
}

export const useCustomMessagePopupStore = create<CustomMessagePopupState>((set, get) => ({
  config: null,
  isLoaded: false,

  loadConfig: async () => {
    const { isLoaded } = get();
    if (isLoaded) return;

    try {
      const { fetchAndActivate } = await import('firebase/remote-config');
      await fetchAndActivate(mainRemoteConfig);
      const rawConfig = getString(mainRemoteConfig, CUSTOM_MESSAGE_POPUP);
      const parsed = JSON.parse(rawConfig);

      set({
        config: parsed,
        isLoaded: true,
      });
    } catch (error) {
      set({
        config: null,
        isLoaded: true,
      });
    }
  },
}));
